"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_USER_HOLDING_VIEW = void 0;
const client_1 = require("@apollo/client");
exports.DELETE_USER_HOLDING_VIEW = client_1.gql `
  mutation deleteUserHoldingView($id: ID!) {
    deleteUserHoldingView(id: $id)
  }
`;
